import styled from 'styled-components';

export const SidebarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${(p) => (p?.horizontalCenter ? 'align-items: center;' : '')}
  ${(p) => (p?.verticalCenter ? 'justify-content: center;' : '')}
  ${(p) => {
    const gap = p?.gap;
    return gap ? `gap: ${gap}` : '';
  }}
`;

export default SidebarWrapper;
